<mat-card>
    <mat-tab-group>
        <mat-tab label="Propuestas Enviadas"> 
            <app-sent></app-sent>
        </mat-tab>
        <mat-tab label="Propuestas Recibidas"> 
            <app-received></app-received>
        </mat-tab>
    </mat-tab-group>
</mat-card>